// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.generated-report-table .report-table-button{padding:0}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/generated-report-table/GeneratedReportTable.scss"],"names":[],"mappings":"AACI,6CACI,SAAA","sourcesContent":[".generated-report-table {\n    .report-table-button {\n        padding: 0;\n        \n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
